<template :style="close ? 'display: none' : ''">
    <div class="ppe_bg">
        <article v-if="!taskDone" class="ppe_container">
            <div v-if="!videoEnded" class="video-container">
                <video ref="myVideo" class="video-screen" autoplay @play="handleVideoPlay" @ended="handleVideoEnded">
                    <source :src="videoUrl" type="video/mp4" />
                </video>
                <div v-if="!videoStarted" class="ppe_play" @click="playVideo">
                    <img class="ppe_video_icon" src="@/assets/img/ppe/video-play-icon.png" alt="play icon">
                </div>
            </div>
            <img class="ppe_title_img" :src="mediaPath" />
            <div v-if="videoEnded">
                <p class="ppe_info">
                    {{ properties.title }}

                </p>
                <p class="ppe_description">{{ properties.description }}</p>

                <section class="ppe_content">

                    <div @dragenter.prevent="handleDragEnter" @dragover.prevent @dragleave.prevent="handleDragLeave"
                        @drop="handleDrop">
                        <div class="ppe_doll_container">
                            <Outfit v-for="(item, index) in properties.outfit" :key="index" :item="item"
                                :outfitItems="outfitItems" />
                        </div>
                        <div :class="isDragOver
                            ? 'ppe_doll_border ppe_dragged_over'
                            : 'ppe_doll_border'
                            "></div>
                    </div>
                    <ClothCards v-for="(item, index) in properties.cloth" :key="index" :item="item"
                        :outfit="outfitItems" @remove-item="handleRemoveItem" />
                </section>
                <div class="ppe_btns">
                    <div class="ppe_btn_remove" @click="handleRemoveAll">
                        <img src="@/assets/img/ppe/redo-arrow-button.png" alt="arrow icon" />
                        REMOVE ALL
                    </div>
                    <div class="ppe_btn_ready" @click="handleReady">
                        <img src="@/assets/img/ppe/button-arrow.png" alt="arrow icon" />
                        I'M READY
                    </div>
                </div>
            </div>
        </article>
        <Solution v-if="taskDone" :properties="properties" :isMatching="isMatching"
            @closeComponent="handleCloseComponent" />
    </div>
</template>

<script>
import ClothCards from "../ppe-components/ClothCards.vue";
import Outfit from "../ppe-components/Outfit.vue";
import Solution from "../ppe-components/Solution.vue";

export default {
    props: ["properties", "pageData", "slug"],
    components: {
        ClothCards,
        Outfit,
        Solution,
    },
    data() {
        return {
            outfitItems: [],
            solution: [],
            isDragOver: false,
            isMatching: null,
            taskDone: false,
            close: false,
            videoEnded: false,
            videoStarted: false,
        };
    },
    mounted() {
        this.initializeDragged();
        // mute sound
        app.api.Utils.muteAudioManager();
    },

    unmounted() {
        // unmute sound (if not livestream player open)
        let openContent = app.api.PageManager.getOpenContentComponents();
        if (openContent.some(item => item.type === 'livestreamPlayer')) {
            return;
        }
        app.api.Utils.unmuteAudioManager();
    },
    methods: {
        handleDrop(event) {
            event.preventDefault();
            const data = event.dataTransfer.getData("text/plain");
            const droppedItem = JSON.parse(data);
            this.outfitItems.push(droppedItem);
            this.isDragOver = false;
            this.dragCounter = 0;
        },
        handleVideoPlay() {
            this.videoStarted = true;
        },
        handleDragEnter(event) {
            event.preventDefault();
            this.dragCounter++;
            this.isDragOver = true;
        },
        handleDragLeave(event) {
            event.preventDefault();
            this.dragCounter--;
            if (this.dragCounter === 0) {
                this.isDragOver = false;
            }
        },

        handleVideoEnded() {
            this.videoEnded = true;
        },

        handleRemoveItem(item) {
            this.outfitItems = this.outfitItems.filter(
                (outfitItem) => outfitItem.title !== item.title
            );

        },
        handleRemoveAll() {
            this.outfitItems = [];

        },
        handleReady() {
            this.splitAndPushItems(this.properties.solution);
            this.checkMatches();
            this.taskDone = true;
            this.outfitItems = [];
        },

        splitAndPushItems(itemsString) {
            const items = itemsString
                .match(/"([^"]+)"/g)
                .map((item) => item.replace(/"/g, ""));
            items.forEach((item) => {
                this.solution.push({ title: item });
            });

        },
        playVideo() {
            this.$refs.myVideo.play();
            this.videoStarted = true;
        },
        initializeDragged() {
            const itemsToCheck = ["Wristwatch", "Necklace"];
            itemsToCheck.forEach((itemTitle) => {
                const item = this.properties.cloth.find(
                    (clothItem) => clothItem.title === itemTitle
                );
                if (item) {
                    this.outfitItems.push(item);

                }
            });
        },
        checkMatches() {
            const outfitTitles = this.outfitItems.map((item) => item.title);
            const solutionTitles = this.solution.map((item) => item.title);
            
            if(this.properties.scene == "Milk reception"){
                //check if "Necklace" is in outfitTitles and remove it from outfitTitles
                const necklaceIndex = outfitTitles.indexOf("Necklace");
                if(necklaceIndex > -1){
                    outfitTitles.splice(necklaceIndex, 1);
                }
                const safetyGlovesIndex = outfitTitles.indexOf("Gloves");
                if(safetyGlovesIndex > -1){
                    outfitTitles.splice(safetyGlovesIndex, 1);
                } 
            }
            
            console.log("outfitItems", outfitTitles);
            // Check if all items in outfitItems are in solution
            const allOutfitItemsMatch = outfitTitles.every((title) =>
                solutionTitles.includes(title)
            );
            // Check if all items in solution are in outfitItems
            const allSolutionItemsMatch = solutionTitles.every((title) =>
                outfitTitles.includes(title)
            );

            this.isMatching = allOutfitItemsMatch && allSolutionItemsMatch;
            this.solution = [];

        },
        handleCloseComponent() {

            this.$emit("closeComponent", this.slug);

            // omit future auto open 
            app.api.LocalDataStore.set(this.slug, true);
        }
    },
    computed: {
        videoUrl() {
            return app.api.Utils.getMediaPath(this.properties.video.src);
        },
        mediaPath() {
            return app.api.Utils.getMediaPath(this.properties.titleImage.src);
        }
    },
};
</script>

<style lang="scss">
.ppe_bg {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    z-index: 4 !important;
    background-color: rgba(0, 0, 0, 0.7);
}

.video-screen {
    position: absolute;
    top: 0px;
    top: 0px;
    left: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
    object-fit: cover;

}

.ppe_video_icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 150px;
    height: 150px;
    z-index: 12;
    cursor: pointer;
}

.ppe_play {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 11;
    cursor: pointer;
}

.ppe_container {
    position: relative;
    width: 1451px;
    height: 816px;
    background-color: var(--light-grey);
    border: 10px solid var(--beige-grey);
    border-radius: 20px;

}

.ppe_btns {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);

    .ppe_btn_remove,
    .ppe_btn_ready {
        cursor: pointer;
        padding: 8px 16px;
        border-radius: 20px;
        width: 150px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        font-family: "Arla Interface";
        font-weight: 700;
        font-style: normal;
        font-display: swap;

        img {
            margin-top: 2px;
        }
    }

    .ppe_btn_remove {
        border: solid 1px var(--rusty-red);
        color: var(--rusty-red);
    }

    .ppe_btn_ready {
        margin-top: 10px;
        background-color: var(--dark-green);
        color: var(--white);
    }
}

.Warehouse {
    padding: 0px 10px;
    background-color: var(--rusty-red);
    color: #fff;
    border-radius: 10px;
    font-family: "Arla Interface";
    font-weight: 300;
    font-style: normal;
    font-display: swap;
}

.Production {
    background-color: var(--yellow);
    padding: 0px 10px;
    border: solid 1px var(--yellow);
    border-radius: 10px;
    color: var(--yellow-brown);
    font-family: "Arla Interface";
    font-weight: 300;
    font-style: normal;
    font-display: swap;
}

.Milk {
    background-color: var(--baby-blue);
    padding: 0px 10px;
    color: var(--petrol);
    border-radius: 10px;
    font-family: "Arla Interface";
    font-weight: 300;
    font-style: normal;
    font-display: swap;
}


.ppe_title_img {
    position: absolute;
    top: 12px;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 11;
}

.ppe_info {
    position: absolute;
    font-size: 15px;
    color: var(--md-black);
    font-family: "Arla Interface";
    font-weight: 500;
    font-style: normal;
    font-display: swap;
    top: 65px;
    width: 700px;
    left: 50%;
    transform: translate(-50%, -50%);
}

.ppe_description {
    position: absolute;
    font-size: 15px;
    color: var(--md-black);
    font-family: "Arla Interface";
    font-weight: 700;
    font-style: normal;
    font-display: swap;
    top: 105px;
    left: 50%;
    transform: translate(-50%, -50%);
}



.ppe_doll {
    position: absolute;
    top: 55%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 223px;
    height: 471px;
    z-index: 1;
    display: block;
}

.ppe_women_doll {
    position: absolute;
    top: 55%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 200px;
    height: 471px;
    z-index: 1;
    display: block;
}

.ppe_doll_border {
    border: 2px solid var(--white);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 330px;
    height: 530px;
    z-index: 20;
}

.ppe_dragged_over {
    z-index: 20;
    background-color: #ffffff44;
}

.ppe_doll_container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 330px;
    height: 511px;
}

.outfit_vest {
    position: absolute;
    left: 111px;
    top: 159px;
    z-index: 2;
}

.outfit_mens_sleeves {
    position: absolute;
    left: 87px;
    top: 155px;
    z-index: 1;
}

.outfit_womens_sleeves {
    position: absolute;
    left: 91px;
    top: 147px;
    z-index: 1;
}

.outfit_mens_shoes {
    position: absolute;
    left: 53px;
    top: 466px;
    z-index: 1;
}

.outfit_womens_shoes {
    position: absolute;
    left: 53px;
    top: 466px;
    z-index: 1;
}

.outfit_mens_gloves {
    position: absolute;
    left: 90px;
    top: 309px;
    z-index: 1;
}

.outfit_womens_gloves {
    position: absolute;
    left: 96px;
    top: 309px;
    z-index: 1;
}

.outfit_bump {
    position: absolute;
    left: 102px;
    top: 8px;
    z-index: 2;
}

.outfit_hair_front {
    position: absolute;
    left: 110px;
    top: 35px;
    z-index: 1;
}

.outfit_hair_back {
    position: absolute;
    left: 124px;
    top: 108px;
    z-index: 0;
}

.outfit_beard {
    position: absolute;
    left: 133px;
    top: 112px;
    z-index: 1;
}

.outfit_hearing {
    position: absolute;
    left: 108px;
    top: 35px;
    z-index: 4;
}

.outfit_glasses {
    position: absolute;
    left: 134px;
    top: 92px;
    z-index: 1;
}

.outfit_wristwatch {
    position: absolute;
    left: 219px;
    top: 288px;
    z-index: 1;
}

.outfit_necklace {
    position: absolute;
    left: 143px;
    top: 155px;
    z-index: 1;
}
</style>
